import { getLang } from '../i18n';

const dateFormatters = new Map<string, Intl.DateTimeFormat>();

/** Locale-aware short date-time; ISO strings from the API may lack a zone. */
export function formatDateTime(iso: string | null): string {
  if (iso === null || iso === '') return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const locale = getLang() === 'ru' ? 'ru-RU' : 'en-GB';
  let formatter = dateFormatters.get(locale);
  if (formatter === undefined) {
    formatter = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
    dateFormatters.set(locale, formatter);
  }
  return formatter.format(date);
}

/** Short preview for table cells; keeps the full value in a `title` attribute. */
export function truncate(value: string | null, max = 80): string {
  if (value === null || value === '') return '—';
  return value.length > max ? `${value.slice(0, max - 1)}…` : value;
}

export function pageCount(total: number, limit: number): number {
  return Math.max(1, Math.ceil(total / Math.max(1, limit)));
}
